export enum OfferSelection {
  NONE = "none",
  CUSTOM = "custom",
}
